import React from "react";

const FacebookIcon = () => {
  return (
    <svg
      width="12"
      height="24"
      viewBox="0 0 12 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 3.98383L9.82467 3.98483C8.11926 3.98483 7.78909 4.82659 7.78909 6.06192V8.78573H11.8564L11.855 13.0521H7.78909V24H3.54672V13.0521H0V8.78573H3.54672V5.63966C3.54672 1.9883 5.6942 0 8.83029 0L12 0.00523762L11.9998 3.98383Z"
        fill="#3F3F3F"
      />
    </svg>
  );
};

export default FacebookIcon;
